import { LinearProgress } from '@mui/material'
import images from 'assets/images'
import AuthTemplate from 'components/templates/AuthTemplate'
import useGoogleAuth from 'hooks/useGoogleAuth'

const AuthGoogle = () => {
  const { message, loading } = useGoogleAuth()

  return (
    <AuthTemplate>
      <img alt="Google logo" style={{ width: '40%', maxWidth: '250px' }} src={images.GOOGLE_PAGE_LOGO} />

      {loading && <LinearProgress sx={{ my: '40px', maxWidth: '400px', mx: 'auto' }} />}

      <p>{message}</p>
    </AuthTemplate>
  )
}

export default AuthGoogle
